import {
  UPDATE_TAB_INDEX,
} from './constants'
import {
  createReducer,
} from 'helpers/ReducerUtil'

const updateTabIndex = (tabIndex, action) => action.tabIndex

const tabIndexReducer = createReducer(0, {
  [UPDATE_TAB_INDEX]: updateTabIndex,
})

export default tabIndexReducer
